import { messages } from './messages';

import type { Reporter } from './types';
import type { useIntl } from 'react-intl';

export const formatPickingExceptionMessage = (
  intl: ReturnType<typeof useIntl>,
  reasons: string[],
  reporter: Reporter | null | undefined,
): string => {
  const reporterName = reporter?.name;
  const reason = reasons[0];

  const formattedReasons =
    reasons.length === 1 ? reason : `${reasons.slice(0, -1).join(', ')} ${intl.formatMessage(messages.and)} ${reasons[reasons.length - 1]}`;

  if (reasons.length === 1) {
    return reporterName
      ? intl.formatMessage(messages.pickingExceptionSingleReasonWithReporter, {
          reason,
          reporterName,
        })
      : intl.formatMessage(messages.pickingExceptionSingleReason, { reason });
  }

  return reporterName
    ? intl.formatMessage(messages.pickingExceptionMultipleReasonsWithReporter, {
        reasons: formattedReasons,
        reporterName,
      })
    : intl.formatMessage(messages.pickingExceptionMultipleReasons, {
        reasons: formattedReasons,
      });
};
